// lib/auth-utils.ts
import { useAuthStore } from "./auth-store";

interface UserResponse {
  user: any;
}

/**
 * Attempts to log in a user from a token.
 * Updates the auth store if successful.
 * @param token JWT token string
 * @returns The fetched user object or null if failed
 */
export async function loginWithToken(token: string): Promise<any | null> {
  const { login, logout } = useAuthStore.getState(); // get Zustand store methods directly
  console.log("[loginWithToken] Starting login with token:", token);

  try {
    const res = await fetch(`${process.env.NEXT_PUBLIC_API}/api/account/me`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    console.log("[loginWithToken] Fetch response status:", res.status);

    if (!res.ok) {
      const errText = await res.text();
      console.log("[loginWithToken] Fetch failed:", errText);
      logout();
      return null;
    }

    const data: UserResponse = await res.json();
    console.log("[loginWithToken] Response data:", data);

    if (!data.user) {
      console.log("[loginWithToken] No user found in response, logging out...");
      logout();
      return null;
    }

    login(data.user);
    console.log("[loginWithToken] User logged in successfully:", data.user);

    return data.user;

  } catch (error) {
    console.log("[loginWithToken] Error during login:", error);
    logout();
    return null;
  }
}
